import { WeatherSettingsChangeSource } from '@fe/weather';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import SettingsSubSection from '../../../common/SettingsSubSection';
import { useDropdownSetting } from '../sections/hooks/useSetting';
import { MinimumDsuaOptions } from '../settings-options';

export default function DsuaMenu() {
    const minimum = useDropdownSetting(MinimumDsuaOptions, 'dsua', 'minimumLevel', WeatherSettingsChangeSource.dsua);

    return (
        <div className="d-flex flex-column gap-2 px-3 py-2" style={{ minWidth: '300px' }}>
            <SettingsSubSection title="Dynamic SUA">
                <div className="d-flex flex-column">
                    <div>Maximum time range</div>
                    <DropDownList {...minimum} />
                </div>
            </SettingsSubSection>
        </div>
    );
}
